import React from "react";
import { FormField } from "./FormField";
import "./StudyLinksField.scss";

interface StudyLinksFieldProps {
  links: string[];
  onAdd: () => void;
  onRemove: (index: number) => void;
  onChange: (index: number, value: string) => void;
}

export const StudyLinksField: React.FC<StudyLinksFieldProps> = ({
  links,
  onAdd,
  onRemove,
  onChange,
}) => {
  return (
    <FormField label="참고 링크" className="article-links-field">
      <div className="article-links">
        {links.map((link, index) => (
          <div key={index} className="article-link-item">
            <input
              type="url"
              value={link}
              onChange={(e) => onChange(index, e.target.value)}
              placeholder="참고 링크를 입력하세요"
              className="article-link-input"
            />
            {links.length > 1 && (
              <button
                type="button"
                onClick={() => onRemove(index)}
                className="remove-link-btn"
                title="링크 삭제"
              >
                ×
              </button>
            )}
          </div>
        ))}
        <button type="button" onClick={onAdd} className="add-link-btn">
          + 링크 추가
        </button>
      </div>
    </FormField>
  );
};
